<template>
  <v-expansion-panels v-model="panelIndex" flat>
    <v-expansion-panel>
      <v-expansion-panel-title>
        <img v-if="imgSrc" :src="imgSrc" alt="avatar" />
        <TextBody tag="span" :text="title" :body-type="2" weight="medium" />
        <span v-if="collectionName" class="collection-name"> from {{ collectionName }}</span>
      </v-expansion-panel-title>
      <v-expansion-panel-text>
        <slot></slot>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script setup>
import { ref, watch, nextTick, defineProps, defineEmits } from 'vue';

import TextBody from '~/components/common/TextBody';

const props = defineProps({
  title: { type: String, default: '' },
  collectionId: { type: String, default: '' },
  collectionName: { type: String, default: '' },
  modelValue: { type: Boolean, default: false },
  imgSrc: { type: String, default: '' },
});

const emit = defineEmits(['update:modelValue']);

const panelIndex = ref(null);

nextTick(() => {
  panelIndex.value = props.modelValue ? 0 : null;
});

watch(panelIndex, (val) => {
  if ((val !== null) !== props.modelValue) {
    emit('update:modelValue', val !== null);
  }
});

watch(
  () => props.modelValue,
  (val) => {
    if ((panelIndex.value !== null) !== val) {
      panelIndex.value = val ? 0 : null;
    }
  },
);
</script>

<style scoped lang="scss">
.collection-name {
  @include bb-regular-text-styles('lg');
  font-weight: 500;
  margin-left: $bb-spacing-1;
  cursor: pointer;
}

img {
  margin-right: $bb-spacing-2;
}
</style>
